module.exports = __webpack_public_path__ + "img/device-tracking.7b194343.svg";